export default "__VITE_ASSET__DA3Eu2gn__"